"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _constants = require("../utils/constants");

var _default = {
  title: 'Item Size Ratio',
  description: "The option sets the ratio between the width and height of the item, this is a string that will be evaluated on runtime. Use 'X%/Y%' to indicate that the ratio is responsive. e.g.\n  '1' is a square, '16/9' is a wide screen rectangle and '100%/50%' is full width and half the height of the container",
  isRelevant: function isRelevant(styleParams) {
    return styleParams.cubeImages;
  },
  "default": 1
};
exports["default"] = _default;